import { ref, computed } from 'vue'
import { useI18n } from 'vue-i18n'

const currentLocale = ref(localStorage.getItem('locale') || 'tr')

export function useLanguage() {
  const { locale } = useI18n()

  const availableLocales = [
    { code: 'tr', name: 'Türkçe', flag: '🇹🇷' },
    { code: 'en', name: 'English', flag: '🇬🇧' },
    { code: 'el', name: 'Ελληνικά', flag: '🇬🇷' }
  ]

  const currentLanguage = computed(() => {
    return availableLocales.find(l => l.code === currentLocale.value) || availableLocales[0]
  })

  function changeLanguage(newLocale: string) {
    currentLocale.value = newLocale
    locale.value = newLocale
    localStorage.setItem('locale', newLocale)
  }

  return {
    currentLocale,
    currentLanguage,
    availableLocales,
    changeLanguage
  }
}
